import { PAGE_TYPES } from 'app/RenderingEnvironment/const';

import * as LOCAL_PREVIEWERS from './const';

/**
 * get name of the local previewer component to use for the given page type
 * @param {object} params - function params
 * @param {boolean} [params.isStatic] - static content override
 * @param {string} [params.pageType] - page type
 * @returns {string} local previewer name
 */
export const getLocalPreviewerName = function getLocalPreviewerName({ isStatic, pageType }) {
  if (isStatic) {
    return LOCAL_PREVIEWERS.STATIC_CONTENT;
  }

  switch (pageType) {
    case PAGE_TYPES.APP:
    case PAGE_TYPES.DEFAULT:
    case PAGE_TYPES.DYNAMIC:
    case PAGE_TYPES.FLASH_EVENT:
    case PAGE_TYPES.HOMEPAGE:
    case PAGE_TYPES.PERSONALIZED_HOMEPAGE:
    case PAGE_TYPES.RESPONSIVE_CONTENT:
    case PAGE_TYPES.SPACE:
      return LOCAL_PREVIEWERS.NUI;
    case PAGE_TYPES.STATIC_CONTENT:
      return LOCAL_PREVIEWERS.STATIC_CONTENT;
    default:
      // show payload in dev and a fallback message in prod
      return process.env.NODE_ENV === 'development' ? LOCAL_PREVIEWERS.PAYLOAD : pageType;
  }
};
